import { render, staticRenderFns } from "./TheProgram.vue?vue&type=template&id=4c275f1e&scoped=true"
import script from "./TheProgram.vue?vue&type=script&lang=js"
export * from "./TheProgram.vue?vue&type=script&lang=js"
import style0 from "./TheProgram.vue?vue&type=style&index=0&id=4c275f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c275f1e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EducationStreamListChangeSelection: require('/builds/gb-developers/geekbrains-client/components/pages/education/StreamList/ChangeSelection.vue').default,EducationProgramsListProgramProductInner: require('/builds/gb-developers/geekbrains-client/components/pages/education/ProgramsList/Program/ProductInner.vue').default,EducationProgramsListTrajectoriesStepInfo: require('/builds/gb-developers/geekbrains-client/components/pages/education/ProgramsList/Trajectories/StepInfo/StepInfo.vue').default,EducationProgramsListProgramPlugsEmptyPlug: require('/builds/gb-developers/geekbrains-client/components/pages/education/ProgramsList/Program/Plugs/EmptyPlug.vue').default,EducationProgramsListProgramPlugsCompletedPlug: require('/builds/gb-developers/geekbrains-client/components/pages/education/ProgramsList/Program/Plugs/CompletedPlug.vue').default})
